<style>
</style>

<template>
  <div class="nav-tabs-custom mb-0"
       v-if="canReadRates || canReadCompliance"
  >
    <ul class="nav nav-tabs pl-0">
      <li v-if="canReadCompliance"
          :class="{'active': activeTab === 'compliance'}"
          @click="activeTab = 'compliance'"
      >
        <a href="#compliance" data-toggle="tab">Compliance</a>
      </li>
      <li v-if="canReadRates"
          :class="{'active': activeTab === 'rates'}"
          @click="activeTab = 'rates'"
      >
        <a href="#rates" data-toggle="tab">Rates</a>
      </li>
    </ul>
    <div class="tab-content active pa-0">
      <compliance v-show="activeTab === 'compliance'"></compliance>
      <rates v-show="activeTab === 'rates'"></rates>
    </div>
  </div>
</template>

<script>
// TODO: This view should actually be a part of another one - company settings or similar.
// Currently it falls under user account settings.
// Need to create a separate main menu item for company settings and move management of compliance,
// rates, departments and cost centres there.

// TODO: These components need better names. Like 'RatesManagementPanel' or similar
import Compliance from '@/views/Compliance.vue';
import Rates from '@/views/Rates.vue';

export default {
  components: {
    Compliance,
    Rates,
  },

  data() {
    return {
      canReadRates: window.canReadRates,
      canUpdateRates: window.canUpdateRates,
      canReadCompliance: window.canReadCompliance,
      canUpdateCompliance: window.canUpdateCompliance,

      activeTab: 'compliance',
    };
  },
};

</script>
